import { CommonModule, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import {
  AlertController,
  IonApp,
  IonIcon,
  IonItem,
  IonMenu,
  IonRouterOutlet,
  IonSelect,
  IonSelectOption,
  IonToast,
  MenuController,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/lib/lib-ngx/services/alert.service';
import { ErrorService } from 'src/lib/lib-ngx/services/error.service';
import { ApiPublicService } from 'src/lib/lib-ngx/web-services/api-public.service';
import { MenuComponent } from './components/menu/menu.component';
import { ContactService } from './services/contact.service';
import { GAdsService } from './services/gads.service';
import { UserTrackingService } from './services/user-tracking.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  styleUrls: ['./app.component.scss'],
  imports: [
    IonApp,
    IonRouterOutlet,
    RouterModule,
    IonIcon,
    CommonModule,
    IonToast,
    TranslateModule,
    IonSelect,
    IonSelectOption,
    IonMenu,
    MenuComponent,
    IonItem,
  ],
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private errorService: ErrorService,
    public alertService: AlertService,
    private alertController: AlertController,
    private contactService: ContactService,
    private gAdsService: GAdsService,
    private menuController: MenuController,
    private userTrackingService: UserTrackingService,
    apiPublicService: ApiPublicService
  ) {
    addIcons({ closeOutline });
    apiPublicService.get().subscribe();
  }

  ngOnInit() {
    this.userTrackingService.loadGtm();
    this.gAdsService.init();
    registerLocaleData(localeFr, 'fr');
    registerLocaleData(localeEn, 'en');

    this.errorService.setModal(async (text: string) => {
      const alert = await this.alertController.create({
        keyboardClose: false,
        backdropDismiss: false,
        header: this.translate.instant('common.errors.title'),
        message: text,
        buttons: [this.translate.instant('common.actions.ok')],
      });
      await alert.present();
      await alert.onDidDismiss();
      return true;
    });

    FirebaseAnalytics.initializeFirebase({
      ...environment.firebase,
    }).then(() => {
      FirebaseAnalytics.setCollectionEnabled({
        enabled: true, // TODO: should depend on cookie consent
      });
    });

    this.userTrackingService.trackIdentify();
    this.contactService.load();
  }

  getAlertClass() {
    const type = this.alertService.getType();
    if (!type) {
      return '';
    }
    return `badge-${type.toLowerCase()}`;
  }

  closeMenu() {
    this.menuController.close('main-menu');
  }
}
